import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import {
  AccountFacilityEligibleQueryParams,
  AccountFacilityEligibleResult,
  AccountPledgeQueryParams,
  AccountPledgeQueryResult,
  AccountPledgeResultData,
  Facility
} from "./account-pledge.model";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "common";

@Injectable({providedIn: "root"})
export class AccountPledgeService {
  private readonly facilitiesUrl: string;
  private readonly accountsUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly settings: ConfigService) {
      this.facilitiesUrl = `${this.settings.environment.facilities.url}/facilities`;
      this.accountsUrl = `${this.settings.environment.loans.url}/api/account`;
  }

  getUnpledgedLoans(params: AccountPledgeQueryParams): Observable<AccountPledgeQueryResult> {
    return this.http.get<AccountPledgeQueryResult>(`${this.accountsUrl}/unpledged`, {params: <any>params});
  }

  getLoansEligibleForFacility(params: AccountFacilityEligibleQueryParams): Observable<AccountFacilityEligibleResult> {
    return this.http.get<AccountFacilityEligibleResult>(`${this.accountsUrl}/eligible-for-facility`, {params: <any>params});
  }

  getFacilities(active: boolean): Observable<Facility[]> {
    return this.http.get<Facility[]>(`${this.facilitiesUrl}/all`, {params: <any>{ active }});
  }

  pledgeLoans(loanIds: number[], facilityId: number): Observable<AccountPledgeResultData> {
    return this.http.patch<AccountPledgeResultData>(`${this.accountsUrl}/pledge`, {loanIds, facilityId});
  }
}